import React from "react"
import styled from "styled-components"
import MVVideoPlayer from "../MVVideoPlayer"
import MVModal from "../MVModal"
import CloseIcon from "../Icons/CloseIcon"

const ModalVideoContainer = styled.div`
  position: relative;
`

const CloseModal = styled.div`
  width: 30px;
  height: 30px;
  position: absolute;
  top: 0;
  right: 10px;
  z-index: 102;
  & svg {
    width: 20px;
  }
`

export default class MVVideoModal extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      showCloseIcon: true,
    }

    this.onUserActive = this.onUserActive.bind(this)
    this.onUserInActive = this.onUserInActive.bind(this)
    this.onVideoEnd = this.onVideoEnd.bind(this)
  }

  onUserActive() {
    this.setState({ showCloseIcon: true })
  }

  onUserInActive(isEnd) {
    this.setState({ showCloseIcon: isEnd || false })
  }

  onVideoEnd() {
    const { closeOnEnd, onClose } = this.props

    this.setState({ showCloseIcon: true })

    if (closeOnEnd) {
      setTimeout(onClose, 1000)
    }
  }

  render() {
    const {
      src,
      type,
      onClose,
      isOpen,
      autoPlay,
      controls,
      endScreen,
      trackingName,
      noForm,
    } = this.props
    //const { showCloseIcon } = this.state;

    return (
      <MVModal isOpen={isOpen} onCloseCallback={onClose}>
        <CloseModal onClick={onClose}>
          <CloseIcon />
        </CloseModal>
        <ModalVideoContainer>
          <MVVideoPlayer
            source={src}
            type={type}
            autoPlay={autoPlay}
            controls={controls}
            onUserActive={this.onUserActive}
            onUserInactive={this.onUserInActive}
            onVideoEnd={this.onVideoEnd}
            endScreen={endScreen}
            noForm={noForm}
            trackingName={trackingName}
          />
        </ModalVideoContainer>
      </MVModal>
    )
  }
}
